import React from 'react';

const Services = () => {
  return (
    <section className="services">
      <div className="service-item">
        <img src="/guide.jpg" alt="guide" />
        <h2>8000+ Our Local Guides</h2>
      </div>
      <div className="service-item">
        <img src="/reability.jpg" alt="reliability" />
        <h2>100% Trusted Tour Agency</h2>
      </div>
      <div className="service-item">
        <img src="/experience.jpg" alt="experience" />
        <h2>28+ Years of Travel Experience</h2>
      </div>
      <div className="service-item">
        <img src="/happy.jpg" alt="feedback" />
        <h2>98% Our Travelers are Happy</h2>
      </div>
    </section>
  );
};

export default Services;